export default {"src":"/_next/static/media/error-gif.21b287ba.gif","height":600,"width":800,"blurWidth":0,"blurHeight":0};